import type { StoreReviewRatingDistribution } from '~/services/api/generated'

type ReviewStar = 1 | 2 | 3 | 4 | 5

const STAR_KEYS = {
  1: 'one_star',
  2: 'two_star',
  3: 'three_star',
  4: 'four_star',
  5: 'five_star'
} as const satisfies Record<ReviewStar, keyof StoreReviewRatingDistribution>

export const ReviewRatingDistribution = {
  EMPTY: {
    five_star: 0,
    four_star: 0,
    one_star: 0,
    three_star: 0,
    two_star: 0
  } satisfies StoreReviewRatingDistribution,
  STARS_DESCENDING: [5, 4, 3, 2, 1] satisfies ReviewStar[],
  count: (distribution: StoreReviewRatingDistribution, star: ReviewStar): number =>
    distribution[STAR_KEYS[star]]
} as const
